import React from 'react';

function CustomLine({ txt }) {
    return (
        <div
            style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: "-10px" }}
        >
            <div style={{ flex: 1, height: '2px', backgroundColor: " #D0D6DE" }} />

            <div>
                <p style={{ width: '45px', textAlign: 'center', color: "#D0D6DE", marginTop: "8px" }}>{txt}</p>
            </div>

            <div style={{ flex: 1, height: '2px', backgroundColor: "#D0D6DE" }} />
        </div>
    )
}

export default CustomLine